import React from "react";
import Logo from "../components/Logo";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { VilleLogo } from "../components/Variables";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { FaRegEnvelope } from "react-icons/fa";

export default class NavBootstrap extends React.Component {
  constructor(props) {
    super(props);
    this.state = { toggled: false };
    this.handler = this.handler.bind(this);
    this.handlerSubMenu = this.handlerSubMenu.bind(this);
  }

  handler() {
    this.setState((prevState) => ({
      toggled: !prevState.toggled,
    }));
    if (this.state.active === true) {
      this.setState({ active: false });
    }
  }

  // for the opérations submeny
  handlerSubMenu() {
    this.setState((prevState) => ({
      active: !prevState.active,
    }));
  }

  render() {
    return (
      <NavWrapper className="fixed-top">
        <Navbar expand="lg" className="bg-body-tertiary">
          <Container>
            <Navbar.Brand href="/">
              {" "}
              <Logo />
              Créateurs d'intérieur <VilleLogo />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto w-100">
                <Nav.Link href="/" className="mobile-only">
                  Accueil
                </Nav.Link>
                <NavDropdown
                  title="Métiers"
                  id="basic-nav-dropdown"
                  css={css`
                    @media (max-width: 768px) {
                      padding-top: 8px;
                    }
                  `}
                >
                  <NavDropdown.Item href="/architecte-interieur/">
                    Architecte d'intérieur
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/decorateur-interieur/">
                    Décorateur d'intérieur
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/architecte/">
                    Architecte
                  </NavDropdown.Item>

                  <NavDropdown.Item href="/jardinier-paysagiste/">
                    Jardinier paysagiste / Architecte paysagiste
                  </NavDropdown.Item>
                </NavDropdown>
                <NavDropdown title="Prestations" id="basic-nav-dropdown">
                  <NavDropdown.Item href="/conseil-avant-achat/">
                    Conseil avant achat immobilier
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/conseil-achat-sur-plan/">
                    Conseil achat sur plan / VEFA
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/relooking-interieur/">
                    Relooking d'intérieur
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/renovation-energetique/">
                    Rénovation énergétique
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/extension/">
                    Extension / Agrandissement
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/architecte-interieur-handicap-PMR/">
                    Architecture d'intérieur handicap / PMR
                  </NavDropdown.Item>

                  <NavDropdown.Item href="/architecture-commerciale/">
                    Architecture commerciale
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/architecture-tertiaire/">
                    Architecture tertiaire
                  </NavDropdown.Item>

                  <NavDropdown.Item href="/marches-publics-appel-offres/">
                    Marchés publics / Appels d'offres
                  </NavDropdown.Item>
                </NavDropdown>
                <Nav.Link href="/realisations/">Réalisations</Nav.Link>
                <Nav.Link href="/avant-apres/">Avant-Après</Nav.Link>
                <Nav.Link href="/qui-sommes-nous/">L'équipe</Nav.Link>

                <Nav.Link href="/tarifs-architecte-interieur/">Tarifs</Nav.Link>
                <Nav.Link href="/contact/" className="nav-button">
                  <FaRegEnvelope
                    css={css`
                      font-size: 17px;
                      font-weight: 300;
                      margin-right: 8px;
                      margin-top: -5px;
                    `}
                  />
                  Contactez-nous
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </NavWrapper>
    );
  }
}

const NavWrapper = styled.div`
  background-color: white !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.098);
`;
